// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://kylswengfvlqlwoirmck.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imt5bHN3ZW5nZnZscWx3b2lybWNrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDkyNTYzNjQsImV4cCI6MjA2NDgzMjM2NH0.qqPeh5ByzkbjlumySyuj0-ZgTPrx_kOBWA8ZGS2fioo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);